<template>
  <v-card class="mt-6 bottomCard" flat :rounded="false">
    <v-card-text class="px-0">
      <v-container id="DashboardBottomCardContent">
        <v-row class="align-center justify-center">
          <v-col cols="12" md="7">
            <div class="d-flex align-center">
              <slot name="icon"></slot>
              <slot name="content"></slot>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="5"
            class="d-flex"
            :class="$vuetify.display.mdAndUp ? 'justify-end' : 'justify-center'"
            v-if="showCallToActionButton"
          >
            <OnexButton
              id="btn"
              variant="outlined"
              color="primary"
              width="320"
              @click="callToActionCallback"
            >
              {{ callToActionButtonText }}
            </OnexButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  emits: ['callToActionButtonClicked'],
  components: {
    OnexButton,
  },
  props: {
    callToActionButtonText: {
      type: String,
      required: false,
    },
    showCallToActionButton: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    callToActionCallback() {
      this.$emit('callToActionCallback');
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.bottomCard {
  background: #d6d6d6;
}
</style>
